import { contentItemAction } from '../../actions/contentItemActions';
import { menuAction } from '../../actions/menuActions';
import { trackingAction } from './student/tracking/itemsTrackingActions';
import { isMenuItem } from '@ael/core-api';

export enum SideMenuCondition {
  expanded = 'expanded',
  collapsed = 'collapsed',
  buttonHidden = 'buttonHidden',
}

export type StudentSideMenuReducerState = {
  sideMenuCondition: SideMenuCondition;
};

const defaultState: StudentSideMenuReducerState = {
  sideMenuCondition: SideMenuCondition.expanded,
};

export function createStudentSideMenuReducer(isInPreview: boolean, isLinearModeOn: boolean) {
  // In preview manager wants to see the side menu so that can navigate more quickly
  const shouldNotExpandSideMenuSoThatLinearModeButtonIsMoreProminent = !isInPreview && isLinearModeOn;

  const startingState = shouldNotExpandSideMenuSoThatLinearModeButtonIsMoreProminent
    ? { sideMenuCondition: SideMenuCondition.collapsed }
    : defaultState;

  return (state: StudentSideMenuReducerState = startingState, action: any): StudentSideMenuReducerState => {
    switch (action.type) {
      case menuAction.TopMenu_ToggleLeftSideMenu:
        if (state.sideMenuCondition !== SideMenuCondition.expanded) {
          return { ...state, sideMenuCondition: SideMenuCondition.expanded };
        }
        return { ...state, sideMenuCondition: SideMenuCondition.collapsed };

      case menuAction.SideMenu_SelectNonSequencedFlowItem:
      case menuAction.SideMenu_SelectSequencedFlowItem:
      case menuAction.SideMenu_SelectedResource:
      case menuAction.SideMenu_SelectedQuiz:
        return { ...state, sideMenuCondition: SideMenuCondition.collapsed };

      case menuAction.SideMenu_SelectedSubmenuItem: {
        const isSubmenuAndHasStartingMessage =
          isMenuItem(action.payload.selectedItem) && !!action.payload.selectedItem.startingMessage;
        if (isSubmenuAndHasStartingMessage) {
          return { ...state, sideMenuCondition: SideMenuCondition.collapsed };
        }
        return state;
      }

      case menuAction.SideMenu_HideSideMenuButton:
        if (state.sideMenuCondition === SideMenuCondition.collapsed) {
          return { ...state, sideMenuCondition: SideMenuCondition.buttonHidden };
        }
        return state;

      case menuAction.SideMenu_UnhideSideMenuButton:
        if (state.sideMenuCondition === SideMenuCondition.buttonHidden) {
          return { ...state, sideMenuCondition: SideMenuCondition.collapsed };
        }
        return state;

      case contentItemAction.SequencedContent_Finish_Selected:
      case contentItemAction.Quiz_QuizClosed:
      case menuAction.SideMenu_DeselectedResource:
      case contentItemAction.MenuItemStartingMessage_Dismissed:
        if (shouldNotExpandSideMenuSoThatLinearModeButtonIsMoreProminent && action.payload.isMobile) {
          return state;
        }
        return { ...state, sideMenuCondition: SideMenuCondition.expanded };

      case contentItemAction.SequencedContent_GoTo_Selected:
      case menuAction.SideMenu_SelectHotspot:
        if (action.payload.isMobile) {
          return { ...state, sideMenuCondition: SideMenuCondition.collapsed };
        }
        return state;
      case trackingAction.Tracking_ResetProgress:
        if (shouldNotExpandSideMenuSoThatLinearModeButtonIsMoreProminent && action.isMobile) {
          return { ...state, sideMenuCondition: SideMenuCondition.collapsed };
        }
        return state;
      default:
        return state;
    }
  };
}
